SlideView = require("views/slide")
{ dpi }   = require("lib/device")

class ImageSlideView extends SlideView
  template: require("./template")

  events: ->
    events   = {}

    tapEvent = if @options.data.size is "zoom" then "touch:tap" else "iostap"
    if @options.data.tapAnywhere and not @hasCaption()
      events[tapEvent] = "submit"
    else
      events["iostap .btn-done"]     = "submit"
      events["iostap"]               = "showZoom"

    events

  serialize: ->
    data = super

    data.hasCaption = @hasCaption()

    if data.tapAnywhere and not data.hasCaption
      data.hasPrompt = true
      data.prompt = i18n("image.tap-to-continue")
    else if data.hasCaption
      data.hasPrompt = true

    data

  hasCaption: ->
    @options.data.caption?.title or @options.data.caption?.content

  beforeShow: ->
    @trigger("ui", flexibleHeight: true)

  beforeHide: ->
    @photoswipe?.currItem.container?.classList.add("pswp--smooth-exit")
    $(@photoswipe?.container)
      .closest("#photoswipe")
      .attr("class", "pswp")

    @photoswipe?.close()
    @trigger("ui", flexibleHeight: false)

  show: ->
    @setState(false, "focus")
    @setState("prompt")
    img = @findOne("img")

    onLoad = =>
      img.removeEventListener("load", onLoad)
      @setState(true, "loaded")
      @showZoom() if @options.data.autofocus

    if img.complete
      onLoad()
    else
      img.addEventListener "load", onLoad

  showZoom: (e, showAnimationDuration = 300) ->
    @setState("touched")
    @setState(true, "focus")

    img = @findOne("img")
    pad = if @options.data.compose then 12 else 0
    { top, left, width } = img.getBoundingClientRect()
    thumbBounds = { x: left + pad, y: top + pad, w: width - pad * 2 }

    @photoswipe = new PhotoSwipe(
      document.querySelector("#photoswipe")
      PhotoSwipeUI_Default
      [
        msrc: img.src
        src:  img.src
        title:
          written.wrapInTag(@options.data.caption.title, "h1") +
          written.wrapInTag(@options.data.caption.content, "div")
        w: (img.naturalWidth  or img.width)  / Math.min(dpi, 1.66)
        h: (img.naturalHeight or img.height) / Math.min(dpi, 1.66)
      ]
      {
        showAnimationDuration
        focus: false
        history: false
        barsSize: {top: 0, bottom: 0 }
        getThumbBoundsFn: -> thumbBounds
      }
    )

    @photoswipe.listen("close", => @setState(false, "focus"))
    @photoswipe.init()

  submit: (e) ->
    e?.stopImmediatePropagation()
    super

  refresh: (params) ->
    if _.isEqual params.data.caption, @options.data.caption
      @photoswipe?.close()
    else
      showCaption = true

    super

    if showCaption
      @showZoom(null, 0)


module.exports = ImageSlideView
